import template from './fieldsList.template.html';

export default {
  template,
  bindings: {
    fields: '<',
    onClick: '&',
    onChange: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listServiceNew) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.fields = ctrl.fields || [];
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.fields, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.click = ($event, data) => {
        ctrl.onClick({ event: $event, data });
      };

      ctrl.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.fields && changes.fields.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
